import axios from "axios";

export default {
    namespaced: true,
    state: {
        polist:[],
        po_info:{}
    },
    getters:{
        polist(state){
            return state.polist
        },
        po_info(state){
            return state.po_info
        }
    },  
    mutations:{
        SET_PO_LIST (state, payload) {
            state.polist = payload
        },
        SET_PO_INFO (state, payload) {
            state.po_info = payload
        }
    },
    actions:{
       async getPOList(context,param){
        const response = await axios.get('/api/poLists',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){

                context.commit('SET_PO_LIST',response.data)
            }
       }
    }
}